module.exports = __webpack_public_path__ + "static/media/etsy.4c8a0dd0.svg";